import {
  accountIdentity,
  AccountIdentity,
  AnyAccountId,
  anyAccountId,
  roomContextId,
  RoomContextId,
  RoomId,
  roomId,
  StreamId,
  streamId,
  StreamIsActive,
  streamIsActive,
  StreamKind,
  streamKinds
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamVO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamVO.validationSchema()
  );

  constructor(readonly value: RoomStreamVORaw) {
    JsonSchemaValidator.assert(RoomStreamVO.validation, this.value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: [
        "accountId",
        "accountIdentity",
        "roomId",
        "roomContextId",
        "streamIsActive",
        "streamId",
        "streamKinds"
      ],
      properties: {
        accountId: anyAccountId,
        accountIdentity,
        roomId,
        roomContextId,
        streamIsActive,
        streamId,
        streamKinds
      }
    };
  }
}

interface RoomStreamVORaw {
  accountId: AnyAccountId;
  accountIdentity: AccountIdentity;
  roomId: RoomId;
  roomContextId: RoomContextId;
  streamIsActive: StreamIsActive;
  streamId: StreamId;
  streamKinds: StreamKind[];
}
